module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practice-landing"
  }, [_c('video-modal', {
    attrs: {
      "open": _vm.videoModalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section intro practice-section-1"
  }, [_c('div', {
    staticClass: "container practice-cover-div",
    attrs: {
      "id": "p-c-div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Health Care Professional premier clinical solution")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn practice-signup-button",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up")])], 1)])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('b', [_vm._v("LogBox Practice uses the latest "), _c('br'), _vm._v("technology to conveniently capture and "), _c('br'), _vm._v("store patient data.\n                        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "practice-lead-text-2"
  }, [_vm._v("Improve patient care, record-keeping, case management and practice efficiency.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-hands"
  })]), _vm._v(" "), _c('h3', [_vm._v("Patient Centric")]), _vm._v(" "), _c('p', [_vm._v("Enterprise-grade demographics capture\n                        "), _c('br'), _vm._v(" and patient onboarding")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-user-friends"
  })]), _vm._v(" "), _c('h3', [_vm._v("Clinical Collaboration")]), _vm._v(" "), _c('p', [_vm._v("Real-time clinical data sharing between\n                        "), _c('br'), _vm._v(" multidisciplinary teams")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('span', {
    staticClass: "section-feature-icons-two"
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  })]), _vm._v(" "), _c('h3', [_vm._v("Cloud Based")]), _vm._v(" "), _c('p', [_vm._v("High-performance web and mobile\n                        "), _c('br'), _vm._v(" applications\n                    ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-2"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-3 section-feature-background"
  }, [_c('PracticeFeatures')], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 p-b-lg"
  }, [_c('ul', {
    staticClass: "feature-list fa-ul"
  }, [_c('li', {
    staticClass: "practice-benefits-title"
  }, [_c('h2', {}, [_vm._v("LogBox benefits")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Avoid repetitive tasks and become\n                                "), _c('br'), _vm._v("digitally efficient")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Profile completeness enforced by\n                                "), _c('br'), _vm._v("the system")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Create seamless clinical workflows")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Accuracy of Data entry")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("Save on printing costs")])]), _vm._v(" "), _c('li', {
    staticClass: "practice-benefits-li"
  }, [_c('p', [_vm._v("POPI compliance")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-4 practice-benefit-section"
  }, [_vm._m(4)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section practice-section-5 section-feature-background white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Learn More")]), _vm._v(" "), _c('p', [_vm._v("Sign up for a free trial")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/priceplans"
    }
  }, [_vm._v("PLANS & PRICING")])], 1)])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#14D3AB"
    },
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn practice-price-plan-btn",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4874c840"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/Practice.vue
// module id = 658
// module chunks = 5